import { ChildProps } from '@/common/util/props'

const SearchConditionAreaContent = ({ children }: ChildProps) => {
  return <div className={'flex w-full flex-col gap-2 p-3'}>{children}</div>
}

export default SearchConditionAreaContent
